class StepSection extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('.step-item');
    if(this.items.length === 0) {
      return;
    }
    this.imageWrapper = this.querySelector('.steps-image-wrapper');
    this.imageClasses = this.imageWrapper.dataset.imageClasses;
    this.items.forEach(i => {
      this.calcHeight(i.querySelector('[data-collapsible-content]'));
      i.addEventListener('click', this.handleClickItem.bind(this));
    });
    this.selectStep(this.items[0])
  }

  setVisibility(content) {
    if(content.children.length === 0) {
      content.style.opacity = 0;
      setTimeout(() => {
        content.style.display = 'none';
      }, 150)
      return false;
    }
    else {
      content.style.display = 'block';
      setTimeout(() => {
        content.style.opacity = 1;
      }, 100)
    }
    return true;
  }

  calcHeight(content) {
    if(!this.setVisibility(content)) return;
    const contentHeight = calcHeight(content, this);
    content.style.setProperty('--content-height', `${contentHeight}px`);
  }

  handleClickItem(e) {
    e.preventDefault();
    if(e.currentTarget.dataset.state === 'inactive') {
      this.selectStep(e.currentTarget);
    }
  }

  selectStep(step) {
    step.setAttribute('data-state', 'active');
    const image = step.querySelector('.step-image');
    if(image) {
      this.setImage(image);
    }
  }

  setImage(image) {
    const clone = image.cloneNode(true);
    this.imageWrapper.innerHTML = '';
    this.imageWrapper.append(clone);
    clone.setAttribute('class', this.imageClasses);
  }
}

customElements.define('step-section', StepSection);